import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import type { AwarenessState, Participant } from "@worktools/shared";
import { getAuthToken, getDevIdentity } from "../api/client";

export type BoardConnection = {
  doc: Y.Doc;
  provider: WebsocketProvider;
  destroy: () => void;
};

function socketUrl(): string {
  const protocol = location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${location.host}/ws`;
}

export function connectBoard(boardId: string, user: Participant): BoardConnection {
  const doc = new Y.Doc();
  // The server checks board access on connect, so identity travels in the query.
  const params: Record<string, string> = { name: user.name };
  const token = getAuthToken();
  if (token) params.token = token;
  const dev = getDevIdentity();
  if (dev) params.devUser = dev.id;
  if (user.avatarUrl) params.avatar = user.avatarUrl;

  const provider = new WebsocketProvider(socketUrl(), boardId, doc, { connect: true, params });

  const initial: AwarenessState = {
    user,
    cursor: null,
    selection: [],
    editing: null,
    camera: null,
    spotlight: null,
    followingId: null,
  };
  provider.awareness.setLocalState(initial);

  return {
    doc,
    provider,
    destroy: () => {
      provider.awareness.setLocalState(null);
      provider.destroy();
      doc.destroy();
    },
  };
}
